module.exports = __webpack_public_path__ + "HelveticaOblique.64cb2ea6db9f63807b3e.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-at3-cliente/src/app/@theme/fontes/Helvetica/HelveticaOblique.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaOblique.woff
// module chunks = styles